// src/components/DePINNetworkAnimation.js - РАЗРЕЖЕННЫЕ SCOUTS В УКАЗАННОЙ ОБЛАСТИ

class DePINNetworkAnimation {
  constructor(map) {
    this.map = map;
    this.isAnimating = false;
    this.animationTimeline = null;
    this.scouts = [];
    this.currentStep = 0;
    
    // 🎯 НОВЫЕ КООРДИНАТЫ ПО ВАШИМ ТОЧКАМ
    this.nycBounds = {
      north: 40.863639,   // 📍 Северная граница
      south: 40.701696,   // 📍 Южная граница  
      east: -73.842914,   // 📍 Восточная граница
      west: -74.148004    // 📍 Западная граница
    };
    
    // 📊 Данные для анимации
    this.totalScouts = 50; // 🔥 УМЕНЬШИЛ количество для меньшего наложения
    this.scoutGrowthSteps = [1, 5, 15, 25, 40, 50]; // По этапам
    this.minDistanceBetweenScouts = 0.008; // 🔥 МИНИМАЛЬНОЕ РАССТОЯНИЕ МЕЖДУ SCOUTS
    
    console.log('🌐 DePIN Network Animation initialized - Sparse Layout');
  }

  // 🎬 ГЕНЕРАЦИЯ РАЗРЕЖЕННЫХ SCOUTS
  generateMockScouts() {
    const scouts = [];
    let attempts = 0;
    const maxAttempts = this.totalScouts * 10; // Максимум попыток
    
    console.log(`🎯 Generating ${this.totalScouts} scouts with minimum distance ${this.minDistanceBetweenScouts}`);
    
    while (scouts.length < this.totalScouts && attempts < maxAttempts) {
      attempts++;
      
      // Генерируем случайные координаты
      const lat = this.nycBounds.south + Math.random() * (this.nycBounds.north - this.nycBounds.south);
      const lng = this.nycBounds.west + Math.random() * (this.nycBounds.east - this.nycBounds.west);
      
      // 🔥 ПРОВЕРЯЕМ РАССТОЯНИЕ ДО ДРУГИХ SCOUTS
      const tooClose = scouts.some(existingScout => {
        const distance = Math.sqrt(
          Math.pow(existingScout.coordinates[0] - lng, 2) + 
          Math.pow(existingScout.coordinates[1] - lat, 2)
        );
        return distance < this.minDistanceBetweenScouts;
      });
      
      // Если достаточно далеко от других, добавляем
      if (!tooClose) {
        scouts.push({
          id: `scout_${scouts.length}`,
          coordinates: [lng, lat],
          appeared: false,
          coverageRadius: 300 + Math.random() * 200, // 🔥 УМЕНЬШИЛ: 300-500m вместо 800-1200m
          joinStep: Math.floor(Math.random() * this.scoutGrowthSteps.length)
        });
      }
    }
    
    console.log(`✅ Generated ${scouts.length} well-spaced scouts (${attempts} attempts)`);
    
    // Сортируем по расстоянию от центра для органичного роста
    const centerLat = (this.nycBounds.north + this.nycBounds.south) / 2;
    const centerLng = (this.nycBounds.east + this.nycBounds.west) / 2;
    
    scouts.sort((a, b) => {
      const distA = Math.sqrt(Math.pow(a.coordinates[0] - centerLng, 2) + Math.pow(a.coordinates[1] - centerLat, 2));
      const distB = Math.sqrt(Math.pow(b.coordinates[0] - centerLng, 2) + Math.pow(b.coordinates[1] - centerLat, 2));
      return distA - distB;
    });
    
    this.scouts = scouts;
  }

  // 🏗️ СОЗДАНИЕ СЛОЕВ НА КАРТЕ
  async initializeLayers() {
    try {
      // 📍 SCOUT POINTS СЛОЙ
      this.map.addSource('depinScouts', {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: []
        }
      });

      this.map.addLayer({
        id: 'scoutPoints',
        type: 'circle',
        source: 'depinScouts',
        paint: {
          'circle-radius': [
            'interpolate',
            ['linear'],
            ['zoom'],
            8, 2,    
            15, 5    
          ],
          'circle-color': [
            'case',
            ['>', ['get', 'dataLevel'], 5],
            '#32CD32', // Green for high data
            ['>', ['get', 'dataLevel'], 2],
            '#00BFFF', // Blue for medium data
            '#87CEEB'  // Light blue for new scouts
          ],
          'circle-stroke-width': 1,
          'circle-stroke-color': '#FFFFFF',
          'circle-opacity': 0.9
        }
      });

      // 🌊 COVERAGE AREAS СЛОЙ
      this.map.addSource('scoutCoverage', {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: []
        }
      });

      this.map.addLayer({
        id: 'coverageAreas',
        type: 'fill',
        source: 'scoutCoverage',
        paint: {
          'fill-color': [
            'case',
            ['>', ['get', 'dataLevel'], 5],
            '#32CD32', // Rich green for high data
            ['>', ['get', 'dataLevel'], 2],
            '#00BFFF', // Blue for medium data
            '#87CEEB'  // Light blue for new areas
          ],
          'fill-opacity': [
            'interpolate',
            ['linear'],
            ['get', 'dataLevel'],
            0, 0.08,  // 🔥 УМЕНЬШИЛ прозрачность (было 0.1)
            10, 0.25  // 🔥 УМЕНЬШИЛ прозрачность (было 0.4)
          ]
        }
      });

      // ⚡ NETWORK LINES СЛОЙ
      this.map.addSource('networkLines', {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: []
        }
      });

      this.map.addLayer({
        id: 'networkConnections',
        type: 'line',
        source: 'networkLines',
        paint: {
          'line-color': '#00BFFF',
          'line-width': 1,
          'line-opacity': 0.2 // 🔥 УМЕНЬШИЛ прозрачность линий (было 0.3)
        }
      });

      console.log('✅ DePIN sparse layers initialized');
      
    } catch (error) {
      console.error('❌ Error initializing DePIN layers:', error);
    }
  }

  // 🎬 ЗАПУСК ПОЛНОЙ АНИМАЦИИ
  async startAnimation() {
    if (this.isAnimating) return;
    
    console.log('🎬 Starting DePIN Sparse Network Animation');
    this.isAnimating = true;
    this.currentStep = 0;
    
    // Генерируем данные и создаем слои
    this.generateMockScouts();
    await this.initializeLayers();
    
    // 🔥 ОПТИМАЛЬНАЯ ПОЗИЦИЯ КАМЕРЫ ДЛЯ НОВОЙ ОБЛАСТИ
    const centerLat = (this.nycBounds.north + this.nycBounds.south) / 2; // ~40.782
    const centerLng = (this.nycBounds.east + this.nycBounds.west) / 2;   // ~-73.995
    
    this.map.flyTo({
      center: [centerLng, centerLat],
      zoom: 11.5, // 🔥 НЕМНОГО БЛИЖЕ для лучшего обзора
      pitch: 0,
      bearing: 0,
      duration: 1000
    });

    // Ждем установки камеры
    setTimeout(() => {
      this.runAnimationTimeline();
    }, 1500);
  }

  // ⏰ TIMELINE АНИМАЦИИ
  async runAnimationTimeline() {
    const timeline = [
      { time: 0, action: () => this.step1_Genesis() },
      { time: 3000, action: () => this.step2_EarlyAdopters() },
      { time: 8000, action: () => this.step3_NetworkEffect() },
      { time: 15000, action: () => this.step4_FullCoverage() },
      { time: 25000, action: () => this.finishAnimation() }
    ];

    for (const step of timeline) {
      if (!this.isAnimating) break;
      
      setTimeout(() => {
        if (this.isAnimating) {
          step.action();
        }
      }, step.time);
    }
  }

  // 🌟 ЭТАП 1: GENESIS
  step1_Genesis() {
    console.log('🌟 Step 1: Genesis - First Scout');
    
    // Показываем первого scout
    const firstScout = this.scouts[0];
    firstScout.appeared = true;
    
    this.updateScoutLayer([firstScout]);
    this.updateCoverageLayer([firstScout]);
    
    // Эффект появления
    this.createBurstEffect(firstScout.coordinates);
  }

  // 🚀 ЭТАП 2: EARLY ADOPTERS
  step2_EarlyAdopters() {
    console.log('🚀 Step 2: Early Adopters');
    
    const earlyScouts = this.scouts.slice(0, 6); // 🔥 УМЕНЬШИЛ с 8 до 6
    earlyScouts.forEach((scout, index) => {
      setTimeout(() => {
        scout.appeared = true;
        this.updateScoutLayer(earlyScouts.filter(s => s.appeared));
        this.updateCoverageLayer(earlyScouts.filter(s => s.appeared));
        this.createBurstEffect(scout.coordinates);
      }, index * 700); // 🔥 УВЕЛИЧИЛ паузу для лучшего эффекта
    });
  }

  // 🔥 ЭТАП 3: NETWORK EFFECT
  step3_NetworkEffect() {
    console.log('🔥 Step 3: Network Effect');
    
    const networkScouts = this.scouts.slice(0, 25); // 🔥 УМЕНЬШИЛ с 40 до 25
    
    // Быстрое появление scouts
    networkScouts.forEach((scout, index) => {
      if (!scout.appeared) {
        setTimeout(() => {
          scout.appeared = true;
          scout.dataLevel = Math.floor(Math.random() * 5) + 1;
          
          const activeScouts = networkScouts.filter(s => s.appeared);
          this.updateScoutLayer(activeScouts);
          this.updateCoverageLayer(activeScouts);
          this.updateNetworkLines(activeScouts);
          
        }, (index - 6) * 200); // 🔥 СКОРРЕКТИРОВАЛ индекс
      }
    });
  }

  // 🌈 ЭТАП 4: FULL COVERAGE
  step4_FullCoverage() {
    console.log('🌈 Step 4: Full Coverage');
    
    // Показываем всех scouts
    this.scouts.forEach(scout => {
      scout.appeared = true;
      scout.dataLevel = Math.floor(Math.random() * 10) + 5;
    });

    this.updateScoutLayer(this.scouts);
    this.updateCoverageLayer(this.scouts);
    this.updateNetworkLines(this.scouts);
    
    // 🔥 НЕ ТАКОЙ ДАЛЕКИЙ ZOOM OUT
    setTimeout(() => {
      const centerLat = (this.nycBounds.north + this.nycBounds.south) / 2;
      const centerLng = (this.nycBounds.east + this.nycBounds.west) / 2;
      
      this.map.flyTo({
        center: [centerLng, centerLat],
        zoom: 10.8,  // 🔥 БЛИЖЕ! Было 10.5
        pitch: 10,   // 🔥 МЕНЬШИЙ НАКЛОН! Было 15
        bearing: 0,
        duration: 2500 // 🔥 БЫСТРЕЕ! Было 3000
      });
    }, 2000);
  }

  // 🔄 ОБНОВЛЕНИЕ SCOUT СЛОЯ
  updateScoutLayer(scouts) {
    const features = scouts.map(scout => ({
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: scout.coordinates
      },
      properties: {
        id: scout.id,
        dataLevel: scout.dataLevel || 1
      }
    }));

    this.map.getSource('depinScouts').setData({
      type: 'FeatureCollection',
      features: features
    });
  }

  // 🌊 ОБНОВЛЕНИЕ COVERAGE СЛОЯ (МАЛЕНЬКИЕ КРУГИ)
  updateCoverageLayer(scouts) {
    const features = scouts.map(scout => {
      // 🔥 МАЛЕНЬКИЕ КРУГИ ПОКРЫТИЯ
      const radius = scout.coverageRadius || 400; // 300-500m
      const steps = 32; // 🔥 УМЕНЬШИЛ steps для производительности
      const coords = [];
      
      // 🎯 ПРАВИЛЬНЫЙ РАСЧЕТ ДЛЯ КРУГА
      const metersPerDegreeLat = 110540; 
      const metersPerDegreeLng = 111320 * Math.cos(scout.coordinates[1] * Math.PI / 180);
      
      for (let i = 0; i < steps; i++) {
        const angle = (i / steps) * 2 * Math.PI;
        const dx = (radius * Math.cos(angle)) / metersPerDegreeLng;
        const dy = (radius * Math.sin(angle)) / metersPerDegreeLat;
        coords.push([
          scout.coordinates[0] + dx,
          scout.coordinates[1] + dy
        ]);
      }
      coords.push(coords[0]); // Замыкаем полигон
      
      return {
        type: 'Feature',
        geometry: {
          type: 'Polygon',
          coordinates: [coords]
        },
        properties: {
          scoutId: scout.id,
          dataLevel: scout.dataLevel || 1
        }
      };
    });

    this.map.getSource('scoutCoverage').setData({
      type: 'FeatureCollection',
      features: features
    });
  }

  // ⚡ ОБНОВЛЕНИЕ NETWORK LINES (МЕНЬШЕ СОЕДИНЕНИЙ)
  updateNetworkLines(scouts) {
    const features = [];
    
    // 🔥 УМЕНЬШИЛ РАДИУС СОЕДИНЕНИЙ для меньшего количества линий
    for (let i = 0; i < scouts.length; i++) {
      for (let j = i + 1; j < scouts.length; j++) {
        const distance = this.calculateDistance(
          scouts[i].coordinates,
          scouts[j].coordinates
        );
        
        // 🔥 СОЕДИНЯЕМ ТОЛЬКО ОЧЕНЬ БЛИЗКИЕ (1.5км вместо 2км)
        if (distance < 1500) {
          features.push({
            type: 'Feature',
            geometry: {
              type: 'LineString',
              coordinates: [scouts[i].coordinates, scouts[j].coordinates]
            },
            properties: {
              distance: distance
            }
          });
        }
      }
    }

    this.map.getSource('networkLines').setData({
      type: 'FeatureCollection',
      features: features
    });
  }

  // 🎆 ЭФФЕКТ BURST
  createBurstEffect(coordinates) {
    // Простой эффект через временную точку
    const burstFeature = {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: coordinates
      },
      properties: {
        effect: 'burst'
      }
    };
    
    // Добавляем и удаляем через секунду
    setTimeout(() => {
      // Здесь можно добавить более сложные эффекты
    }, 1000);
  }

  // 📏 РАСЧЕТ РАССТОЯНИЯ
  calculateDistance(coord1, coord2) {
    const R = 6371000; // Радиус Земли в метрах
    const dLat = (coord2[1] - coord1[1]) * Math.PI / 180;
    const dLng = (coord2[0] - coord1[0]) * Math.PI / 180;
    const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
              Math.cos(coord1[1] * Math.PI / 180) * Math.cos(coord2[1] * Math.PI / 180) *
              Math.sin(dLng/2) * Math.sin(dLng/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c;
  }

  // ⏹️ ОСТАНОВКА АНИМАЦИИ
  stopAnimation() {
    console.log('⏹️ Stopping DePIN sparse animation');
    this.isAnimating = false;
    
    // Очищаем все слои
    this.clearAllLayers();
  }

  // 🧹 ОЧИСТКА СЛОЕВ
  clearAllLayers() {
    try {
      const layersToRemove = ['scoutPoints', 'coverageAreas', 'networkConnections'];
      const sourcesToRemove = ['depinScouts', 'scoutCoverage', 'networkLines'];
      
      layersToRemove.forEach(layerId => {
        if (this.map.getLayer(layerId)) {
          this.map.removeLayer(layerId);
        }
      });
      
      sourcesToRemove.forEach(sourceId => {
        if (this.map.getSource(sourceId)) {
          this.map.removeSource(sourceId);
        }
      });
      
    } catch (error) {
      console.warn('⚠️ Error clearing DePIN layers:', error);
    }
  }

  // ✅ ЗАВЕРШЕНИЕ АНИМАЦИИ
  finishAnimation() {
    console.log('✅ DePIN Sparse Network Animation completed');
    
    setTimeout(() => {
      this.isAnimating = false;
    }, 2000);
  }

  // 📊 СТАТИСТИКА
  getStats() {
    const activeScouts = this.scouts.filter(s => s.appeared).length;
    
    return {
      isAnimating: this.isAnimating,
      activeScouts: activeScouts,
      totalScouts: this.totalScouts,
      currentStep: this.currentStep,
      minDistance: this.minDistanceBetweenScouts
    };
  }
}

export default DePINNetworkAnimation;